import { Reducer } from '@reduxjs/toolkit';

const appRoleReducer: Reducer = (state, { payload }) => {
  if (!state) {
    return { role: null };
  }

  if (!payload) {
    return state;
  }

  return { ...state, role: payload };
};

export default appRoleReducer;
